--------------------------------------------------------------------------------
--
-- Session main
--
--------------------------------------------------------------------------------


module App.Main exposing (main)

import Aio.Lib.Flags
import Aio.Model
import Aio.Msg
import Aio.Update
import Aio.View
import Browser



--------------------------------------------------------------------------------
--
-- Main
--
--------------------------------------------------------------------------------


main : Program Aio.Lib.Flags.T Aio.Model.Model Aio.Msg.Msg
main =
    Browser.application
        { init = Aio.Update.initializeApp
        , update = Aio.Update.update
        , view = Aio.View.view
        , subscriptions = Aio.Update.subscribe
        , onUrlChange = Aio.Msg.UrlChanged
        , onUrlRequest = Aio.Msg.UrlRequest
        }



--------------------------------------------------------------------------------
